import type { FirstInstallOnboardingProduct } from "@redotech/redo-model/onboarding";
import type { FirstInstallStep } from "./first-install-flow";

/**
 * Decides whether the Continue button's click handler should synchronously
 * pre-open a blank tab so the post-finishOnboarding redirect to
 * setup.getredo.com survives Chrome/Firefox/Safari popup blockers.
 *
 * Pre-open only when this click will trigger onboarding completion AND the
 * resulting destination is likely to be the external onboarding app:
 *  - Click must finish the flow. On non-product flows (vertical app installs)
 *    that's the attribution step; otherwise it's the product step.
 *  - Chargebacks resolve to an in-app /finance/disputes route on the server,
 *    so don't pre-open for that selection.
 *  - Shopify test stores have shouldRedirect suppressed, so no tab is needed.
 */
export function shouldPreOpenExternalTab(args: {
  isShopifyTestStore: boolean;
  productSelectionRequired: boolean;
  selectedProduct: FirstInstallOnboardingProduct | null;
  step: FirstInstallStep | null;
}): boolean {
  if (args.isShopifyTestStore) {
    return false;
  }
  const finishingStep = args.productSelectionRequired
    ? "product"
    : "attribution";
  if (args.step !== finishingStep) {
    return false;
  }
  if (args.productSelectionRequired) {
    if (!args.selectedProduct) {
      return false;
    }
    if (args.selectedProduct === "chargebacks") {
      return false;
    }
  }
  return true;
}
